import { Box, Stack, Typography } from '@mui/material';
import { PageContent } from 'components/PageContent';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { useEffect } from 'react';
import { getFeatureLanguages, savePage } from 'services/content.service';
import {
	getPages,
	getFeature,
	getPermission,
	isLoading,
	getCurrentTab,
	setCurrentTab,
	getCurrentData,
	getOriginCurrentData,
} from 'state/reducers/content.reducers';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { TabsMenu } from './TabsMenu';
import { ButtonComponent } from './ButtonComponent';
import { featureTitleEnum } from 'constants/ui.constants';
import { PlansContentApp } from 'pages/PlansContentApp';
import { hasPermission } from './AuthorizationComponent';
import _ from 'lodash';

export const Feature = () => {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const featureTitle = useAppSelector(getFeature);
	const featurePermission = useAppSelector(getPermission);
	const pages = useAppSelector(getPages);
	const loading = useAppSelector(isLoading);
	const currentTab = useAppSelector(getCurrentTab);
	const currentData = useAppSelector(getCurrentData);
	const originCurrentData = useAppSelector(getOriginCurrentData);
	const currentPermission = hasPermission([featurePermission]);

	useEffect(() => {
		if (featureTitle) {
			dispatch(getFeatureLanguages());
		}
	}, [featureTitle]);

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		dispatch(setCurrentTab(newValue));
	};

	return (
		<Stack spacing={2}>
			<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
				<Typography variant="pageTitle">{featureTitle}</Typography>
				<ButtonComponent
					disabled={
						loading || !currentPermission || _.difference(currentData, originCurrentData)?.length === 0
					}
					handleClick={() => {
						dispatch(savePage(_.difference(currentData, _.uniq(originCurrentData))));
					}}
					text={t('button.save_changes')}
				/>
			</Box>
			{featureTitle === featureTitleEnum.PLANS ? (
				<PlansContentApp plans={pages} />
			) : (
				<>
					<TabsMenu tabs={pages} currentTab={currentTab} handleChange={handleChange} />
					<PageContent page={pages[currentTab]} />
				</>
			)}
		</Stack>
	);
};
